import { render, staticRenderFns } from "./CommandCreate.vue?vue&type=template&id=1f59489c&"
import script from "./CommandCreate.vue?vue&type=script&lang=js&"
export * from "./CommandCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports